import { render } from "./BirdsEye.vue?vue&type=template&id=36da32ba&scoped=true"
import script from "./BirdsEye.vue?vue&type=script&lang=js"
export * from "./BirdsEye.vue?vue&type=script&lang=js"

import "./BirdsEye.vue?vue&type=style&index=0&id=36da32ba&scoped=true&lang=css"
import "./BirdsEye.vue?vue&type=style&index=1&id=36da32ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da32ba"]])

export default __exports__